import { storage } from "./storage"

export const THEME_DARK = "dark"
export const THEME_LIGHT = "light"

export function isValidTheme(value) {
  return value === THEME_DARK || value === THEME_LIGHT
}

export function resolveSystemTheme() {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return THEME_DARK
  }

  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? THEME_DARK
    : THEME_LIGHT
}

export function resolveInitialTheme() {
  const storedTheme = storage.getTheme()
  if (isValidTheme(storedTheme)) return storedTheme

  if (typeof document !== "undefined") {
    const activeTheme = document.documentElement.getAttribute("data-theme")
    if (isValidTheme(activeTheme)) return activeTheme
  }

  return resolveSystemTheme()
}

export function applyTheme(theme) {
  if (!isValidTheme(theme) || typeof document === "undefined") return

  document.documentElement.setAttribute("data-theme", theme)
  document.documentElement.style.colorScheme = theme
}
